// extracted by mini-css-extract-plugin
module.exports = {"container":"Slogan_container__2saQb","content":"Slogan_content__3jQGH"};